import {useState} from 'react'

var Auth=(props)=>{

    var [vkOpen,setVkOpen]=useState(false)
    var [loading,setLoading]=useState(false)
    console.log("PROPS!",props)
    return (<div>
        {(!props.login||props.errorAuth)&&(<div>
            {props.errorAuth&&(<div className="link">Ошибка! Похоже, ссылка устарела.<br/></div>)    }
            <div className="link">Авторизуйтесь, чтобы получить доступ к курсам<br/></div>    
            {vkOpen==false&&<a className="link" onClick={()=>setVkOpen(true)}><span className="auth">Войти через VK</span></a>}
            {vkOpen==true&&(<div><br/><b>!!!</b> Напишите любое сообщение, например "привет", чтобы получить ссылку для доступа.<br/>
                <a className="link" href="https://vk.me/public184222109?ref=authSite&ref_source=course.tantraprem.ru"><span className="auth">Понятно! Перейти VK</span></a>
                </div>)}
          
        </div>)}
         {(props.login&&!props.errorAuth)&&(<div>
            <div className="link">Подтвердите вход<br/></div>    
            {!props.loading&&(<div ><a className="link" onClick={()=>{setLoading(true);props.loginAction.call()}}><span className="auth">{loading?"Подождите...":"Подтвердить"}</span></a></div>)}
            {props.loading&&(<div ><a className="link"><span className="auth">Подождите, идет подтверждение...</span></a></div>)}
            
            </div>
        )}
        
        <style jsx>{` 
            a{
                display:inline-block;
                cursor:pointer;
            } 
        .auth{
            background-color:#4B76A8;
            color:white;
            padding: 10px 10px 7px 10px;
            border-radius:5px;
        }   
        .link{
            padding-top:20px
            }
        
        `}</style>
        </div>)
}

var doAuth=(token)=>{
    document.cookie = "ptq="+token;
    document.location.reload()
}



export default Auth